import React from 'react'
import { Button } from 'react-bootstrap'
import { RiFileExcel2Line } from 'react-icons/ri'


export default function Excel(props) {

    const { onClick, tooltip_content } = props

    return (
        <>
            <Button
                variant="outline-success"
                size='sm'
                onClick={onClick}
                className={localStorage.getItem('lang_key') == 'ar' ? 'me-1' : 'ms-1'}
                data-tooltip-id="global-table-tooltip"
                data-tooltip-content={tooltip_content}
                data-tooltip-place="bottom"
                data-tooltip-class-name="bg-success tooltip_msg"
            >
                <RiFileExcel2Line className='mb-1' size={14} />
            </Button>
        </>
    )
}
